'use strict';

const GroupAction = require('common/domain/action/group');
const BlobCollection = require('common/domain/collection/blob');
const BlobApiFactory = require('common/infra/api/blob-factory');
const BlobSelectorView = require('common/ui/view/blob/selector');
const imageHelper = require('common/ui/template/helper/image');
const MarkdownWriterView = require('common/ui/view/markdown/writer');
const ModalBaseView = require('common/ui/view/modal/base');
const ModalView = require('common/ui/view/modal/index');
const Template = require('balus/ui/template/body/group/modal/group-setting.hbs');
const Balus = require('common/util');
const i18n = require('i18next');
require('backbone.stickit');
require('bootstrap');

module.exports = ModalBaseView.extend({
    bindings: {
        'input.name': 'name'
    },
    modelEvents: {
        'change:name': 'uploadable',
        'change:image_url': 'uploadable',
        'change:description': 'uploadable'
    },

    events: {
        'change input.use_v2': 'onChangeUseV2',
        'click .image-selector': 'showImageSelector'
    },

    initialize: function() {
        this.original = this.model;
        this.model = this.model.clone();

        _.bindAll(this, 'setting', 'error', 'deleteImage', 'onChangeUseV2');
    },

    setImage: function() {
        if(this.$('.image')) {
            this.$('.image').attr('src', imageHelper(this.model.get('image_url'), 'small'));
        }
    },

    changeDeleteImageButton: function() {
        if (this.model.get('image_url')) {
            this.$('.delete-image').show();
        } else {
            this.$('.delete-image').hide();
        }
    },

    onChangeUseV2: function () {
        this.model.set({ use_v2: this.$('input.use_v2').is(':checked') });
        this.trigger('formFilled');
    },

    deleteImage: function() {
        this.model.set({image_url: null});
    },

    resetModel: function() {
        this.unstickit();
        this.stopListening(this.model);
        this.listenTo(this.model, 'validated:invalid', this.setErrors);
        this.listenTo(this.model, 'change', this.changeDeleteImageButton);
        this.stickit();
    },

    uploadable: function () {
        if(this.model.get('name')) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    render: function() {
        const json = this.model.toJSON();
        json.id = this.model.id;
        this.$el.html($(Template(json)));

        this.stickit();
        this.setupModal();

        const blobApi = BlobApiFactory.buildGroup(this.model.id);

        if (!this.$writer) {
            this.$writer = new MarkdownWriterView({
                markdown: this.model.get('description'),
                useUploader: true,
                useBlobSelector: true,
                blobApi: blobApi
            });
            this.$('.group-description .input').append(this.$writer.render().$el);
        }

        this.listenTo(this.$writer, 'change', function(desc){
            this.model.set('description', desc);
        });
        this.listenTo(this.model, 'change', this.setImage);

        this.changeDeleteImageButton();
        this.listenTo(this.model, 'change', this.changeDeleteImageButton);
        this.$('.delete-image').click(this.deleteImage);

        return this;
    },

    showImageSelector: function(){
        const blobCollection = new BlobCollection();
        const blobApi = BlobApiFactory.buildGroup(this.model.id);

        const imageSelector = new ModalView({
            title: i18n.t('blobSelector.title.imageOnly'),
            bodyView: new BlobSelectorView({
                blobs: blobCollection,
                imageOnly: true,
                useUploader: true,
                blobApi: blobApi
            }),
            onChildviewSave: function() {
                this.disableButtons();
                this.getOption('bodyView').select()
                    .then((blobs) => {
                        this.trigger('selected', blobs);
                        this.hide();
                    });
            }
        });
        imageSelector.show();

        blobCollection.fetch({
            url: blobApi.path()
        });
        this.listenTo(imageSelector, 'selected', function(blob) {
            this.model.set({image_url: blob.url()});
        });
        this.listenTo(this.model, 'change', this.setImage);
    },

    setting: function() {
        return new Promise((resolve, reject) => {
            const isValid = this.model.isValid(true);

            if(!isValid) {
                Balus.logger.warn('UserSetting ValidationError:', this.model.validationError);
                return false;
            }

            GroupAction.updateGroup({group: this.model.toJSON()})
                .then(() => {
                    resolve();
                })
                .catch((status) => {
                    this.error(status);
                    reject();
                });
        });
    },

    error: function(status) {
        if (status && status.type == 'EmptyNameError') {
            this.$('.name .alert-message').html(
                i18n.t('input.group.validation.required')
            );
        }
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/group/modal/group-setting.js